import { safeboxClient } from 'myNet'

const ROUTE = '/v1/categories'

interface ApiResponse<T = any> {
  code: number
  message: string
  data?: T
}

interface ErrorWithCode extends Error {
  code: number
}

interface CreateRequest {
  [key: string]: any
}

interface ResourceDeleteRequest {
  id: string
  request: any
}

const CategoriesService = {
  post: async (request: CreateRequest): Promise<ApiResponse> => {
    const response = await safeboxClient.post(`${ROUTE}`, request)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  get: async (request?: any): Promise<ApiResponse> => {
    const response = await safeboxClient.get(`${ROUTE}`, request)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  delete: async (id: string): Promise<ApiResponse> => {
    const response = await safeboxClient.delete(`${ROUTE}/${id}`)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  put: async (id: string, request: CreateRequest): Promise<ApiResponse> => {
    const response = await safeboxClient.put(`${ROUTE}/${id}`, request)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  resourcePost: async (id: string, request: CreateRequest): Promise<ApiResponse> => {
    const response = await safeboxClient.post(`${ROUTE}/resources/${id}`, request)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  resourceDelete: async ({ id, request }: ResourceDeleteRequest): Promise<ApiResponse> => {
    const response = await safeboxClient.delete(`${ROUTE}/resources/${id}`, request)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
}

export default CategoriesService
